import React/*, {useState}*/ from 'react';
import {postApi} from '../../../utils/functions';

import CopyBox from '../bbcode/copy-box';
import {
  FacebookShareButton,
	TwitterShareButton,
	PinterestShareButton,
	EmailShareButton,
	FacebookIcon,
	TwitterIcon,
	PinterestIcon,
	EmailIcon
} from "react-share";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

class Share extends React.Component {
	constructor(props) {
    super(props);
    this.state = {
			show: this.props.show ? true : false,
			url: this.props.url,
			media: {},
		};
		this.close = this.close.bind(this);
	}

	async componentDidMount() {

		var params = new URLSearchParams();
		params.append('url', this.props.url);
		let x = await postApi('/api/v2/share', params);
		this.setState({media: x.data});

	}

	close() {
		this.setState({ show: false });
		this.props.close();
	}

	render() {
		return (
			<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="lg" centered>
				<Modal.Header closeButton className="bg-dark">
					<Modal.Title>Share Link</Modal.Title>
				</Modal.Header>
				<Modal.Body className="bg-dark">
					<Row className="my-4">
						<Col xs={12}>
							<CopyBox content={`https://mix365.co.uk${this.state.url}`} />
						</Col>
						<Col xs={12} className="text-center pt-3">
							<FacebookShareButton url={`https://mix365.co.uk${this.state.url}`}><FacebookIcon size={42} round={true} /></FacebookShareButton>&nbsp;&nbsp;
							<TwitterShareButton url={`https://mix365.co.uk${this.state.url}`}><TwitterIcon size={42} round={true} /></TwitterShareButton>&nbsp;&nbsp;
							<PinterestShareButton url={`https://mix365.co.uk${this.state.url}`} media={`https://mix365.co.uk${this.state.media.image}`}><PinterestIcon size={42} round={true} /></PinterestShareButton>&nbsp;&nbsp;
							<EmailShareButton url={`https://mix365.co.uk${this.state.url}`}
								subject={this.state.media.title}
								body={this.state.media.description}
								separator=' '
							><EmailIcon size={42} round={true} /></EmailShareButton>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer className="bg-dark">
					<Button variant="secondary" onClick={this.close}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}
}

export default Share;
